import DriverInfoCell from './container';

export default DriverInfoCell;
